import * as _ from 'lodash'

interface FormProps {
    [key: string]: string | boolean
}


const caseFormPros: {
    [key: string]: string
} = {
    state_id: 'state.value.id',
    county_id: 'county.value.id',
    case_type_id: 'caseType.value.caseTypeId',
    case_sub_type_id: 'caseType.value.id',
    comment: 'description.value',
    business_name:'business_name.value',
    language: 'language.value.name'
};

const priceFormProps: {
    [key: string]: string
} = {
    price: 'price.value',
    payment_type: 'payment_type.value',
};

const caseFormEditPros: {
    [key: string]: string
} = {
    comment: 'description.value',
};

const userFormPros: {
    [key: string]: string
} = {
    email: 'email.value',
    password: 'password.value',
    first_name: 'firstName.value',
    last_name: 'lastName.value',
    business_name: 'businessName.value',
    phone: 'phone.value',
};

const creditCardFormProps: {
    [key: string]: string
} = {
    number: 'number.value',
    exp_month: 'exp_month.value',
    exp_year: 'exp_year.value',
    cvc: 'cvc.value',
    postal_code: 'postal_code.value'
};

const changePasswordProps: {
    [key: string]: string
} = {
    oldPassword: 'oldPassword.value',
    newPassword: 'newPassword.value',
};

const locationFormPros: {
    [key: string]: string
} = {
    court_id: 'court.value.id',
    department_id: 'department.value.id',
    city: 'city.value',
    street: 'street.value',
    zip: 'zip.value',
    full_address: 'full_address.value',
};

const dateFormPros: {
    [key: string]: string
} = {
    date: 'full_date.value',
};

export const CaseFormSerializer = (formData: any, edit: any = null) => {
    const data: FormProps = {};

    if (edit) {
        for (const prop of Object.keys(caseFormEditPros)) {
            data[prop] = _.get(formData, caseFormEditPros[prop])
        }
    } else {
        for (const prop of Object.keys(caseFormPros)) {
            data[prop] = _.get(formData, caseFormPros[prop])
        }
    }

    return data;
};

export const priceFormSerializer = (formData: any) => {
    const data: FormProps = {};

        for (const prop of Object.keys(priceFormProps)) {
            data[prop] = _.get(formData, priceFormProps[prop])
        }
        data.contingency = data.payment_type === 'contingency';

    return data;
};

export const UserFormSerializer = (userData: any, omit?: string) => {
    const data: any = {};
    for (const prop of Object.keys(userFormPros)) {
        if (omit && prop === omit) {
            continue;
        }
        data[prop] = _.get(userData, userFormPros[prop])
    }
    return data;
};

export const CreditCardSerializer = (creditCardData: any) => {
    const data: FormProps = {};
    for (const prop of Object.keys(creditCardData)) {
        data[prop] = _.get(creditCardData, creditCardFormProps[prop])
    }
    return data;
};

export const ChangePasswordSerializer = (changePasswordData: any) => {
    const data: FormProps = {};
    for (const prop of Object.keys(changePasswordData)) {
        data[prop] = _.get(changePasswordData, changePasswordProps[prop])
    }
    return data;
};

export const LocationFormSerializer = (locationData: any) => {
    const data: FormProps = {};
    for (const prop of Object.keys(locationFormPros)) {
        data[prop] = _.get(locationData, locationFormPros[prop])
    }
    return data;
};

export const DateFormSerializer = (dateFormData: any) => {
    const data: FormProps = {};
    for (const prop of Object.keys(dateFormPros)) {
        data[prop] = _.get(dateFormData, dateFormPros[prop])
    }
    return data;
};
